/**
 * AI Documents Feature Routes
 * RAG 기반 AGM 문서 자동 생성
 */

import type { RouteRecordRaw } from 'vue-router';

export const aiDocumentsRoutes: RouteRecordRaw[] = [
  {
    path: '/ai-documents',
    name: 'AIDocuments',
    component: () => import('./views/AIDocumentsView.vue'),
    meta: {
      title: 'AI Documents',
      requiresAuth: true,
      layout: 'full',
      devOnly: true,
    },
  },
  {
    path: '/doc-gen',
    name: 'DocGen',
    component: () => import('./views/DocGenView.vue'),
    meta: {
      title: 'Document Generation',
      requiresAuth: true,
      layout: 'full',
    },
  },
];

export default aiDocumentsRoutes;
